import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import EngineeringIcon from '@mui/icons-material/Engineering';

export const commonChips = [
    { value: "nearmisses", label: 'Near Miss', icon: <WarningAmberIcon style={{ fontSize: "20px", marginBottom: "5px" }} />, color: "error" },
    { value: "actoInseguro", label: 'Acto Inseguro', icon: <ReportGmailerrorredIcon style={{ fontSize: "20px", marginBottom: "5px" }} />, color: "warning" },
    { value: "condicaoInsegura", label: 'Condição Insegura', icon: <EngineeringIcon style={{ fontSize: "20px", marginBottom: "5px" }} />, color: "warning" },
]
